import { gql } from '@apollo/client'

export const Query = gql`
  query Categories($companyId: ID!, $filters: CategoryFilters, $order: CategoryOrder, $after: String, $before: String, $first: Int, $last: Int) {
    categories(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        parent { id fullname color }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
